"use client";

import React, { useState } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import { useAppContext } from "@components/Provider";

const Modal = dynamic(() => import("../Modal/Modal"), { ssr: false });
const Login = dynamic(() => import("../Login/Login"), { ssr: false });
const ForgotPassword = dynamic(
  () => import("../ForgotPassword/ForgotPassword"),
  { ssr: false }
);

const HeaderActionButtons = ({ slug, classNames, onMenuClose }) => {
  const { data, siteId, tokenCookie, hideEBBNl, isMobile, isTablet } =
    useAppContext();
  const [isLoginOpen, setIsLoginOpen] = useState(false);



  const openLoginModal = () => {
    setIsLoginOpen(true);
    // Close the offcanvas menu if onMenuClose function is provided
    if (onMenuClose) {
      onMenuClose();
    }
  };
  const closeLoginModal = () => {
    setIsLoginOpen(false);
  };
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);
  const openForgotPasswordModal = () => {
    closeLoginModal();
    setIsForgotPasswordOpen(true);
  };
  const closeForgotPasswordModal = () => {
    setIsForgotPasswordOpen(false);
  };

  const handleSubscribeClick = () => {
    // Close the offcanvas menu if onMenuClose function is provided
    if (onMenuClose) {
      onMenuClose();
    }
  };
  return (
    <>
      <div className={[classNames?.["header-button-container"], "header-button-container"].join(" ")}>
        {/* For tablet, render Subscribe first, then Sign In */}
          <>
            {!hideEBBNl && (
              <li className={`subscribe`}>
                <Link href="/newsletters-2" onClick={handleSubscribeClick}>
                  Subscribe
                </Link>
              </li>
            )}
            {!tokenCookie && (
              <li className={[classNames?.["signin"], "signin"].join(" ")}>
                <a
                  style={{
                    color: "#000",
                    cursor: "pointer",
                  }}
                  onClick={openLoginModal}
                >
                  Sign In
                </a>
              </li>
            )}
          </>
      </div>
      <Modal
        isOpen={isLoginOpen}
        closeBtn={closeLoginModal}
        className="LoginModal"
      >
        <Login
          openForgotPasswordModal={openForgotPasswordModal}
          closeLoginModal={closeLoginModal}
          buttonText="LOGIN"
          classNames="button"
          hidePlaceHolder={true}
        />
      </Modal>
      <Modal
        isOpen={isForgotPasswordOpen}
        closeBtn={closeForgotPasswordModal}
        className="ForgotPassword"
      >
        <ForgotPassword />
      </Modal>
      <style jsx global>
        {`
          .LoginModal .medium-modal.modal {
            width: 45%;
            padding: 2rem;
            border-radius: 10px;
          }
          .LoginModal .medium-modal.modal .formButton button {
            padding: 1rem;
            background: #7bcffb;
            color: black;
            font-weight: bold;
            font-size: 1.2rem;
          }
          @media (max-width: 1024px) {
            .LoginModal .medium-modal.modal {
              width: 90%;
            }
          }
        `}
      </style>
    </>
  );
};

export default HeaderActionButtons;
